<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title
				:title="getMessage_(screen.menuTitle)"
				useFaivorite
				:faivorite="screen.favoriteYn === 'Y'"
				:onFavorite="onFavorite"
			/>
		</template>
		<template v-slot:content>
			<center-content :scrId="scrId" />
		</template>
	</sf-content-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import CenterContent from './Content/Content.vue';

export default {
	components: { CenterContent },
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		console.clear();
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,

		locations() {
			let result = [];
			// console.log('this.$route', this.$route);
			// console.log('activedTab', this.$sfMenuTab.state.activedTab);
			//console.log('props 확인', this.scrId);
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},
	methods: {
		...rootMethods,
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
